<template>
  <div class="page-template">
    <div class="page-title">{{ title }}
    </div>
    <div class="page-edit">
      <form-template ref="formTemplate" @submit="submitData">
      </form-template>
    </div>
  </div>
</template>

<script>
  import formTemplate from "@/components/template/formTemplate";
  import api from "@/config/api";

  export default {
    components: {formTemplate},
    data() {
      return {
        title: '',
        addColumns: {
          formType: 'other',
          labelWidth: "280px",
          span: 24,
          columns: [
            {label: '会员类', type: 'title'},
            {
              label: "",
              type: "id",
            },
            {
              label: "会员开卡通知",
              type: "radio",
              prop: "openCardNotify",
              data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
            },
            {
              label: "储值余额充值通知",
              type: "radio",
              prop: "balanceConsumeNotify",
              data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
            },
            {
              label: "储值余额消费通知",
              type: "radio",
              prop: "balanceRechargeNotify",
              data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
            },
            {
              label: "会员积分消费提醒",
              type: "radio",
              prop: "integralConsumeNotify",
              data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
            },
            {
              label: "会员消费赠送积分提醒",
              type: "radio",
              prop: "consumeGiveIntegralNotify",
              data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
            },
            {
              label: "会员反充值提醒",
              type: "radio",
              prop: "reverseRechargeNotify",
              data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
            },
          ],
          formData: {}
        }
      }
    },
    mounted() {
      this.title = document.title;
      this.getData();
    },
    methods: {
      submitData(formModel) {
        this.$axios.fetchPost(api.notify.rule, formModel).then(data => {
          if (data.code === 200) {
            Object.assign(formModel, data.data);
            this.$notify({
              type: "success",
              title: '提交操作',
              message: '成功',
              showClose: false,
            });
          } else {
            this.$message({type: 'error', message: data.errorMsg});
          }
        }).catch((e) => {
          this.$notify({
            type: "error",
            title: '提交操作',
            message: '失败',
            showClose: false,
          });
        });
      },
      getData() {
        this.$axios.fetchGet(api.notify.rule + '/detail').then(data => {
          if (data.code === 200) {
            this.addColumns.formData = data.data;
            this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
          } else {
            this.$message({type: 'error', message: data.errorMsg});
          }
        }).catch((e) => {
          this.$message({type: 'error', message: '请求失败'});
        });
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/page/apply/notify/Rule.vue